import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface CompactSidebarToggleProperties {
  isSideNavOpen: boolean;
  isActiveSecondarySideNav: boolean;
}

export interface CompactSidebarState {
  compactSidebarToggleProperties: CompactSidebarToggleProperties;
  compactLeftSideBarBgColor: string;
}

const initialState: CompactSidebarState = {
  compactSidebarToggleProperties: {
    isSideNavOpen: true,
    isActiveSecondarySideNav: false,
  },
  compactLeftSideBarBgColor: 'sidebar-dark-purple',
};

const compactSidebarSlice = createSlice({
  name: 'compactSidebar',
  initialState,
  reducers: {
    changeCompactSidebarProperties(state) {
      state.compactSidebarToggleProperties.isSideNavOpen = !state.compactSidebarToggleProperties.isSideNavOpen;
    },
    changecompactLeftSideBarBgColor(state, action: PayloadAction<string>) {
      state.compactLeftSideBarBgColor = action.payload;
    },
  },
});

export const { changeCompactSidebarProperties, changecompactLeftSideBarBgColor } = compactSidebarSlice.actions;

export const selectCompactSidebarToggleProperties = (state: { compactSidebar: CompactSidebarState }) => state.compactSidebar.compactSidebarToggleProperties;
export const selectCompactLeftSideBarBgColor = (state: { compactSidebar: CompactSidebarState }) => state.compactSidebar.compactLeftSideBarBgColor;
export const selectIsCompactSideNavOpen = (state: { compactSidebar: CompactSidebarState }) => state.compactSidebar.compactSidebarToggleProperties.isSideNavOpen;
export const selectIsCompactActiveSecondarySideNav = (state: { compactSidebar: CompactSidebarState }) => state.compactSidebar.compactSidebarToggleProperties.isActiveSecondarySideNav;

export default compactSidebarSlice.reducer;
